



































import Component, { mixins } from 'vue-class-component';
import BaseFormMixin from '@/mixins/base-form-mixin';
import DimensionForm1 from './dimension-form-1.vue';
import DimensionForm2 from './dimension-form-2.vue';
import DimensionForm3 from './dimension-form-3.vue';
import DimensionForm4 from './dimension-form-4.vue';
import DimensionForm5 from './dimension-form-5.vue';
import DimensionForm6 from './dimension-form-6.vue';
import DimensionServices, { DimensionDto, DimensionItemDto } from '@/services/dimension';
import { Watch } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import { checkCode } from '@/libs/util';

@Component({
  components: { DimensionForm1, DimensionForm2, DimensionForm3, DimensionForm4, DimensionForm5, DimensionForm6 }
})
export default class DimensionForm extends mixins(BaseFormMixin) {
  breadList = [{ name: '创建维表' }];
  dimSrv = new DimensionServices();

  formData: DimensionDto = {};
  dimFieldList: DimensionItemDto[] = [];
  oldFieldList: DimensionItemDto[] = [];
  // 同步方式
  dimSyncDefs: any = {};
  id: any = 0;
  categoryId: any = 0;
  keepalive: boolean = true;

  initFormData() {
    this.dimSyncDefs = {
      cronExpression: '',
      databaseConfig: {
        mappings: [],
        source: {
          databaseName: '', // 数据资源
          sourceId: 1,
          sourceName: '', // 数据源
          tableName: '' // 数据对象
        }
      },
      inputdataConfig: [],
      jobMode: 0,
      sqlqueryConfig: {
        limit: 10,
        pageNo: 1,
        pageSize: 10,
        source: {
          id: 1,
          name: ''
        },
        sqlquery: ``,
        variables: []
      },
      jobConfig: {
        rate: 0,
        runDateFormat: '',
        runDateStr: ''
      },
      syncMode: 0
    };
    this.formData = {};
    this.dimFieldList = [];
    this.current = 0;
  }

  created() {
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;
    this.initFormData();
  }

  activated() {
    this.onIdChange();
  }

  refreshKeepalive() {
    if (!this.$route.query.keepalive) {
      this.keepalive = false;
      this.$router.push({
        query: { ...this.$route.query, keepalive: 'true' }
      });
    } else {
      this.keepalive = true;
    }
  }

  @Watch('$route')
  onRouteChange(to: any, from: any) {
    this.id = this.$route.query.id;
    this.categoryId = this.$route.query.categoryId;
    this.cache = this.isNeedCache(from, to);
    this.onIdChange();
  }

  @Watch('id')
  async onIdChange() {
    let path = this.$route.path;
    if (path == '/decision/dimension/add') {
      this.refreshKeepalive();
      if (this.keepalive && this.cache) return false;

      this.initFormData();

      let categories = await this.dimSrv.getCategory();
      let category = categories.filter((category: any) => category.id == this.categoryId)[0];
      this.breadList = [{ name: category.label }, { name: '创建维度表' }];
    } else if (path == '/decision/dimension/edit') {
      if ((!this.id || this.id == this.formData.id) && this.cache) return false;
      this.spinning = true;
      let res = await this.dimSrv.getInfo(this.id);
      this.spinning = false;
      if (!res) return false;
      this.formData = res.sysDim;
      this.oldFieldList = JSON.parse(JSON.stringify(res.dimFieldList));
      this.dimFieldList = res.dimFieldList;
      this.dimSyncDefs = res.dimSyncDefs;
      this.initEditData(res.dimSyncDefs);
      this.current = 0;
      this.dimSyncDefs.jobConfig = JSON.parse(this.dimSyncDefs.jobConfig);
      this.breadList = [{ name: this.formData.dimCategoryName || '' }, { name: this.formData.dimName || '' }, { name: '编辑维表' }];
    }
  }

  // 解析syncConfig数据
  initEditData(dimSyncDefs: any) {
    this.dimSyncDefs.databaseConfig = { mappings: [], source: { databaseName: '', sourceId: 1, sourceName: '', tableName: '' } };
    this.dimSyncDefs.sqlqueryConfig = { limit: 10, pageNo: 1, pageSize: 10, source: { id: 0, name: '' }, sqlquery: ``, variables: [] };
    this.dimSyncDefs.inputdataConfig = [];
    if (dimSyncDefs.syncMode === 0) {
      this.dimSyncDefs.databaseConfig = JSON.parse(dimSyncDefs.syncConfig);
    }
    if (dimSyncDefs.syncMode === 1) {
      this.dimSyncDefs.sqlqueryConfig = JSON.parse(dimSyncDefs.syncConfig);
    }
    if (dimSyncDefs.syncMode === 2) {
      this.dimSyncDefs.inputdataConfig = JSON.parse(dimSyncDefs.syncConfig || '[]');
    }
  }

  async next() {
    if (this.current === 0) {
      const must: { field: 'dimCode' | 'dimName' | 'dimKind'; msessage: string }[] = [
        { field: 'dimCode', msessage: '维表编码不能为空' },
        { field: 'dimName', msessage: '维表名称不能为空' },
        { field: 'dimKind', msessage: '维表类型不能为空' }
      ];
      for (let val of must) {
        if (!this.formData[val.field]) {
          this.$message.error(val.msessage);
          return false;
        }
      }
      if (!checkCode(this.formData.dimCode)) {
        this.$message.error('编码只能包含英文字母、数字、下划线');
        return false;
      }
      if (!this.id) {
        let code = 'DIM_' + this.formData.dimCode;
        let exist = await this.dimSrv.getList({ dimCode_eq: code });
        if (exist.length > 0) {
          this.$message.error(`编码[${code}]已经存在`);
          return false;
        }
      }
    }
    if (this.current === 1) {
      let result = this.checkDimFieldList();
      if (!result) {
        this.$message.error('请将维表属性填写完整');
        return false;
      }
      let isChange = this.checkFieldsChange();
      if (isChange) {
        this.$confirm({
          title: '提示信息',
          content: '属性编码或属性类型变更，会自动废弃已同步数据。是否继续？',
          onOk: () => {
            this.current++;
          },
          onCancel() {}
        });
        return false;
      }
    }
    this.current++;
  }

  /**
   * 判断属性变更状态
   * 0: 没有变化, 1: 更新, 2:增加,删除
   * 既有增加删除，又有更新记录。优先记录更新
   * 前端只校验是否有更新给提示信息，增加和删除状态提供给后端
   */
  checkFieldsChange() {
    if (this.oldFieldList.length > 0) {
      let isFieldsChange = 0;
      let isRemoved: boolean = false;
      this.oldFieldList.forEach(v => {
        let item = this.dimFieldList.find(s => s.id === v.id);
        if (!item) {
          isRemoved = true;
        } else {
          if (item.fieldCode !== v.fieldCode || item.fieldType !== v.fieldType) isFieldsChange = 1;
        }
      });
      if (isFieldsChange !== 1 && isRemoved) isFieldsChange = 2;
      if (isFieldsChange === 0) isFieldsChange = this.oldFieldList.length === this.dimFieldList.length ? 0 : 2;
      this.formData.isFieldsChange = isFieldsChange;
      return isFieldsChange === 1;
    }
    return false;
  }

  checkDimFieldList() {
    let result = true;
    this.dimFieldList.forEach((v: any) => {
      if (!v.fieldCode || !v.fieldName || !v.fieldType || !v.drillLevel) result = false;
    });

    this.dimFieldList = this.dimFieldList.map((v: any, index: number) => {
      if (!v.fieldCode || !v.fieldName || !v.fieldType || !v.drillLevel) result = false;
      return {
        ...v,
        fieldSort: index + 1
      };
    });

    return result;
  }

  loading: boolean = false;
  async confirm() {
    this.loading = true;
    if (this.id) {
      let res = await this.dimSrv.update({ ...this.formData, dimFieldList: this.dimFieldList, dimSyncDefs: this.dimSyncDefs });
      if (res) {
        this.replaceUrlWithOutConfirm('/decision/dimension/detail?id=' + this.id);
        this.initFormData();
      }
    } else {
      let categoryId: number | boolean = typeof this.$route.query.categoryId === 'string' ? parseInt(this.$route.query.categoryId) : false;
      if (!categoryId) {
        this.$message.error('参数错误：没有指定目录');
        return false;
      }
      this.formData.dimCategoryId = categoryId;
      let res = await this.dimSrv.add({ ...this.formData, dimFieldList: this.dimFieldList, dimSyncDefs: this.dimSyncDefs });
      if (res) {
        this.replaceUrlWithOutConfirm('/decision/dimension/detail?id=' + res.id);
        this.initFormData();
      }
    }
    this.loading = false;
    this.HANDLE_RELOAD_DIM_MENU();
  }
  @Mutation HANDLE_RELOAD_DIM_MENU: any;
}
